import { MINUTES_IN_DAY, MINUTES_IN_HOUR } from '@stdlib/constants-time';

import { EXPERIENCE_DURATION_DESCRIPTION } from 'app/typings/core/common/experiences/enum/experienceDurationDescription';
import type { ExperienceDurationDescription } from 'app/typings/core/common/experiences/enum/experienceDurationDescription';
import type { ExtranetHotelExperience } from 'app/typings/core/extranet/hotel/experiences';

const MINUTES_PER_UNIT: Record<ExperienceDurationDescription, number> = {
  [EXPERIENCE_DURATION_DESCRIPTION.MINUTE]: 1,
  [EXPERIENCE_DURATION_DESCRIPTION.HOUR]: MINUTES_IN_HOUR,
  [EXPERIENCE_DURATION_DESCRIPTION.HALF_DAY]: MINUTES_IN_DAY / 2,
  [EXPERIENCE_DURATION_DESCRIPTION.DAY]: MINUTES_IN_DAY,
};

export const experienceDurationInMinutes = (
  experience?: Pick<
    ExtranetHotelExperience,
    'duration' | 'durationDescription'
  > | null
): number | null => {
  if (!experience?.duration || !experience.durationDescription) {
    return null;
  }

  return experience.duration * MINUTES_PER_UNIT[experience.durationDescription];
};
